import { render, staticRenderFns } from "./OpenPlatformUploadFiles.vue?vue&type=template&id=26654143"
import script from "./OpenPlatformUploadFiles.vue?vue&type=script&lang=js"
export * from "./OpenPlatformUploadFiles.vue?vue&type=script&lang=js"
import style0 from "./OpenPlatformUploadFiles.vue?vue&type=style&index=0&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports